import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid2 } from "@mui/material";
import PieChartCard from "./graphs/PieChartCard";
import { useNavigate, useParams } from "react-router";
import WeekdayChart from "./graphs/WeekdayChart";
import { DateTime } from "luxon";
import HolidayChart from "./graphs/HolidayChart";
import ScatterPlot from "./graphs/ScatterPlot";
import MultiChartCard from "./graphs/MultiChartCard";
import DataGridCard from "./DataGridCard";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import TotalChart from "./graphs/FullTotalCard";
import Text from "../../genericComponents/Text";
import { ElectricMeter, GasMeter, Speed } from "@mui/icons-material";
const BuildingAnalysis = ({ setHeader }) => {
         
    const currentYear=DateTime.now().toObject().year;
    const [start, setStart] = useState(DateTime.utc(currentYear, 1, 1))
    const [end, setEnd] = useState(DateTime.utc(currentYear, 12, 31))
    const params = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        setHeader({ icon: LocationCityIcon, text: params.name });
    }, [setHeader, params])

    const chartHeight = 390;
    const electicityCharts = [
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_total"} /></Grid2>), graph: <TotalChart start={start} end={end} level={"BUILDING"} meterType={"ELECTRICITY"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_weekday"} /></Grid2>), graph: <WeekdayChart start={start} end={end} level={"BUILDING"} meterType={"ELECTRICITY"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_holiday"} /></Grid2>), graph: <HolidayChart start={start} end={end} level={"BUILDING"} meterType={"ELECTRICITY"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><ElectricMeter /><Text text={"i18n_chart_temperature"} /></Grid2>), graph: <ScatterPlot start={start} end={end} level={"BUILDING"} meterType={"ELECTRICITY"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_total"} /></Grid2>), graph: <TotalChart   start={start} end={end} level={"BUILDING"} meterType={"GAS"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_weekday"} /></Grid2>), graph: <WeekdayChart start={start} end={end} level={"BUILDING"} meterType={"GAS"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_holiday"} /></Grid2>), graph: <HolidayChart start={start} end={end} level={"BUILDING"} meterType={"GAS"} id={params.id} height={chartHeight} /> },
        { name: (<Grid2 container spacing={1}><GasMeter /><Text text={"i18n_chart_temperature"} /></Grid2>), graph: <ScatterPlot start={start} end={end} level={"BUILDING"} meterType={"GAS"} id={params.id} height={chartHeight} /> },
    ]
    const defaultFilters = [{ propertyName: "buildingId", comparator: "eq", value: params.id }];
    return (<Box sx={{ flexGrow: 1 }}>
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12 }}>
                <PieChartCard start={start} end={end} level={"BUILDING"} id={params.id} />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <MultiChartCard start={start} setStart={setStart} setEnd={setEnd} end={end} title="i18n_analysis" graphs={electicityCharts} height={chartHeight} />
            </Grid2>
            <Grid2 size={12}>
                <DataGridCard
                    icon={Speed}
                    pageSize={5}
                    defaultFilters={defaultFilters}
                    mandatoryColumnNames="meterType ean18"
                    title={"i18n_meters"}
                    defaultColumns={["displayName", "meterType", "gridOperator", "isTussenMeter", "externalDataProvider"]}
                    onClick={item => navigate("/analysis/meter/" + item.meterType + "/" + item.ean + "/" + item.uuid)}
                    type="meters" />
            </Grid2>
        </Grid2>
    </Box>)
}
export default BuildingAnalysis